const COMBINED_QUANTITY_PATTERN = /^(-?\d+(?:[.,]\d+)?)\s*([^\d\s].*)$/;

export function splitIngredientAmount(quantityNeeded, unit) {
  const quantityText = `${quantityNeeded ?? ""}`.trim();
  const unitText = `${unit ?? ""}`.trim();

  if (!quantityText || unitText) {
    return {
      quantityNeeded: quantityText,
      unit: unitText,
    };
  }

  const match = quantityText.match(COMBINED_QUANTITY_PATTERN);
  if (!match) {
    return {
      quantityNeeded: quantityText,
      unit: unitText,
    };
  }

  return {
    quantityNeeded: match[1].replace(",", "."),
    unit: match[2].trim(),
  };
}

export function formatIngredientAmount(quantityNeeded, unit) {
  const quantityText = `${quantityNeeded ?? ""}`.trim();
  const unitText = `${unit ?? ""}`.trim();

  if (!quantityText) return "";
  return unitText ? `${quantityText} ${unitText}` : quantityText;
}

export function getIngredientStateFromAmount(amount, currentUnit = "") {
  const trimmedAmount = `${amount ?? ""}`.trim();
  const parsed = splitIngredientAmount(trimmedAmount, "");

  return {
    amount: trimmedAmount,
    quantity_needed: parsed.quantityNeeded,
    unit: parsed.unit || `${currentUnit ?? ""}`.trim(),
  };
}

export function normalizeIngredientForForm(ingredient) {
  const { quantityNeeded, unit } = splitIngredientAmount(
    ingredient?.quantity_needed,
    ingredient?.unit,
  );

  return {
    ...ingredient,
    inventory_item_name: ingredient?.inventory_item_name || "",
    quantity_needed: quantityNeeded,
    unit,
    amount: formatIngredientAmount(quantityNeeded, unit),
  };
}

export function sanitizeIngredientForSave(ingredient) {
  const parsed = splitIngredientAmount(
    ingredient?.amount ?? ingredient?.quantity_needed,
    "",
  );

  return {
    inventory_item_id: ingredient?.inventory_item_id,
    inventory_item_name: ingredient?.inventory_item_name || "",
    quantity_needed: parsed.quantityNeeded,
    unit: parsed.unit || `${ingredient?.unit ?? ""}`.trim(),
  };
}
